function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var _require = require('./web3-amount'),
  addDecimalAmounts = _require.addDecimalAmounts,
  multiplyDecimalAmount = _require.multiplyDecimalAmount;
var _require2 = require('./withdrawal-quote'),
  canonicalJson = _require2.canonicalJson,
  quoteTimestamp = _require2.quoteTimestamp,
  quoteIsExpired = _require2.quoteIsExpired,
  signQuote = _require2.signQuote,
  verifyQuote = _require2.verifyQuote;
var SUPPORT_EMAIL = 'info@saito.io';
var SUPPORT_URL = 'https://wiki.saito.io/applications/store/payments';
function treasuryPublicKey(mod) {
  var _mod$app, _mod$app$returnModule;
  var buysaito = (_mod$app = mod.app) === null || _mod$app === void 0 || (_mod$app = _mod$app.modules) === null || _mod$app === void 0 || (_mod$app$returnModule = _mod$app.returnModule) === null || _mod$app$returnModule === void 0 ? void 0 : _mod$app$returnModule.call(_mod$app, 'BuySaito');
  var authorized = String((buysaito === null || buysaito === void 0 ? void 0 : buysaito.authorized_public_key) || '').trim();
  if (authorized) {
    return authorized;
  }
  var configured = mod.web3_payment_processor_publickey;
  var listed = Array.isArray(configured) ? configured : configured ? [configured] : [];
  for (var _i = 0, _arr = [].concat(_toConsumableArray(listed), [mod.publicKey]); _i < _arr.length; _i++) {
    var candidate = _arr[_i];
    var key = String(candidate || '').trim();
    if (key) {
      return key;
    }
  }
  return '';
}
function pairsFromQuote(data) {
  var transfers = Array.isArray(data === null || data === void 0 ? void 0 : data.transfer_uuids) ? data.transfer_uuids : null;
  var payments = Array.isArray(data === null || data === void 0 ? void 0 : data.payment_uuids) ? data.payment_uuids : null;
  if (!transfers || !payments || transfers.length !== payments.length || !transfers.length) {
    return null;
  }
  var seenTransfers = new Set();
  var seenPayments = new Set();
  var pairs = [];
  for (var i = 0; i < transfers.length; i += 1) {
    var transfer = String(transfers[i] || '').trim();
    var payment = String(payments[i] || '').trim();
    if (!transfer || !payment || seenTransfers.has(transfer) || seenPayments.has(payment)) {
      return null;
    }
    seenTransfers.add(transfer);
    seenPayments.add(payment);
    pairs.push({
      transfer: transfer,
      payment: payment
    });
  }
  return pairs;
}
function withdrawalAddressIsValid(ticker, address) {
  try {
    var MixinModule = require('../../mixin/lib/mixinmodule');
    return MixinModule.prototype.validateAddress.call({
      ticker: ticker,
      chain_id: '',
      mixin: null
    }, address) === true;
  } catch (err) {
    return false;
  }
}
function paidToTreasury(tx, treasury) {
  var total = 0n;
  var addressed = false;
  var _iterator = _createForOfIteratorHelper((tx === null || tx === void 0 ? void 0 : tx.to) || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      if (String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '') !== treasury) {
        continue;
      }
      addressed = true;
      try {
        var _slip$amount;
        total += BigInt((_slip$amount = slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0);
      } catch (err) {
        return {
          addressed: false,
          total: 0n
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    addressed: addressed,
    total: total
  };
}
var StoreWithdrawals = /*#__PURE__*/function () {
  function StoreWithdrawals(mod) {
    _classCallCheck(this, StoreWithdrawals);
    this.mod = mod;
    this.quoteSequence = 0;
  }
  return _createClass(StoreWithdrawals, [{
    key: "app",
    get: function get() {
      return this.mod.app;
    }
  }, {
    key: "db",
    get: function get() {
      return this.mod.warehouse.db;
    }
  }, {
    key: "query",
    value: function query(sql, params) {
      return this.app.storage.queryDatabase(sql, params, this.mod.dbname || 'store');
    }
  }, {
    key: "run",
    value: function run(sql, params) {
      return this.app.storage.runDatabase(sql, params, this.mod.dbname || 'store');
    }
  }, {
    key: "treasuryIsConnected",
    value: function treasuryIsConnected(treasury) {
      var _this$app$network;
      var peers = ((_this$app$network = this.app.network) === null || _this$app$network === void 0 ? void 0 : _this$app$network.peers) || [];
      return peers.some(function (peer) {
        return String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '') === treasury;
      });
    }
  }, {
    key: "latestBlockId",
    value: function () {
      var _latestBlockId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$app$blockchain, _this$app$blockchain$, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _t = Number;
              _context.n = 1;
              return (_this$app$blockchain = this.app.blockchain) === null || _this$app$blockchain === void 0 || (_this$app$blockchain$ = _this$app$blockchain.getLatestBlockId) === null || _this$app$blockchain$ === void 0 ? void 0 : _this$app$blockchain$.call(_this$app$blockchain);
            case 1:
              return _context.a(2, _t(_context.v));
            case 2:
              _context.p = 2;
              _t2 = _context.v;
              return _context.a(2, NaN);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function latestBlockId() {
        return _latestBlockId.apply(this, arguments);
      }
      return latestBlockId;
    }()
  }, {
    key: "eligibleSales",
    value: function () {
      var _eligibleSales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(seller, ticker) {
        var latest, wait, rows;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.latestBlockId();
            case 1:
              latest = _context2.v;
              wait = Number(this.mod.web3_withdrawal_blocks);
              if (!(!seller || !ticker || !Number.isFinite(latest) || !Number.isFinite(wait))) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, []);
            case 2:
              _context2.n = 3;
              return this.query("SELECT transfer_uuid, inbound_payment_uuid, web3_amount, quantity_sold, block_id_sold\n       FROM listing_sales\n       WHERE seller = $seller\n         AND UPPER(TRIM(web3_ticker)) = $ticker\n         AND transfer_uuid <> ''\n         AND inbound_payment_uuid <> ''\n         AND web3_payment_withdrawal_processed = 0\n         AND IFNULL(web3_payment_withdrawal_request, '') = ''\n         AND longest_chain_sold = 1\n         AND block_id_sold > 0", {
                $seller: seller,
                $ticker: ticker
              });
            case 3:
              rows = _context2.v;
              return _context2.a(2, (rows || []).filter(function (row) {
                return latest >= Number(row.block_id_sold) + wait;
              }));
          }
        }, _callee2, this);
      }));
      function eligibleSales(_x, _x2) {
        return _eligibleSales.apply(this, arguments);
      }
      return eligibleSales;
    }()
  }, {
    key: "sumSales",
    value: function sumSales(rows) {
      var total = '0';
      var _iterator2 = _createForOfIteratorHelper(rows),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;
          var earned = multiplyDecimalAmount(row.web3_amount, row.quantity_sold);
          if (!earned) {
            return '';
          }
          total = addDecimalAmounts(total, earned);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return total;
    }
  }, {
    key: "createQuote",
    value: function () {
      var _createQuote = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$mod$fee;
        var _ref,
          seller,
          ticker,
          withdrawalAddress,
          symbol,
          address,
          treasury,
          sales,
          withdrawalAmount,
          data,
          privateKey,
          signature,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, seller = _ref.seller, ticker = _ref.ticker, withdrawalAddress = _ref.withdrawalAddress;
              symbol = String(ticker || '').trim().toUpperCase();
              address = String(withdrawalAddress || '').trim();
              treasury = treasuryPublicKey(this.mod);
              if (seller) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, {
                err: 'A signed request is required.'
              });
            case 1:
              if (!(!symbol || symbol === 'SAITO')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, {
                err: 'A web3 ticker is required.'
              });
            case 2:
              if (address) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, {
                err: 'A withdrawal address is required.'
              });
            case 3:
              if (treasury) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2, {
                err: 'The treasury public key is not configured.'
              });
            case 4:
              _context3.n = 5;
              return this.eligibleSales(seller, symbol);
            case 5:
              sales = _context3.v;
              if (sales.length) {
                _context3.n = 6;
                break;
              }
              return _context3.a(2, {
                err: 'No eligible proceeds are available for withdrawal.'
              });
            case 6:
              withdrawalAmount = this.sumSales(sales);
              if (!(!withdrawalAmount || withdrawalAmount === '0')) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2, {
                err: 'No eligible proceeds are available for withdrawal.'
              });
            case 7:
              data = {
                amount: String((_this$mod$fee = this.mod.fee) !== null && _this$mod$fee !== void 0 ? _this$mod$fee : 0),
                publickey: treasury,
                ticker: symbol,
                withdrawal_amount: withdrawalAmount,
                withdrawal_address: address,
                transfer_uuids: sales.map(function (row) {
                  return String(row.transfer_uuid);
                }),
                payment_uuids: sales.map(function (row) {
                  return String(row.inbound_payment_uuid);
                }),
                timestamp: quoteTimestamp(Date.now(), this.quoteSequence += 1)
              };
              _context3.n = 8;
              return this.app.wallet.getPrivateKey();
            case 8:
              privateKey = _context3.v;
              signature = signQuote(this.app.crypto, data, privateKey);
              return _context3.a(2, {
                data: data,
                signature: signature
              });
          }
        }, _callee3, this);
      }));
      function createQuote() {
        return _createQuote.apply(this, arguments);
      }
      return createQuote;
    }()
  }, {
    key: "acceptSubmittedTransaction",
    value: function () {
      var _acceptSubmittedTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(outer) {
        var _outer$returnMessage, _envelope$transaction, _tx$returnMessage, _tx, _tx$from, _outer$from, _this$mod$fee2, _this$app$wallet$conv;
        var serialized,
          message,
          envelope,
          embedded,
          tx,
          stored,
          txmsg,
          sender,
          outerSender,
          existing,
          data,
          signature,
          consumed,
          treasury,
          ticker,
          pairs,
          address,
          sales,
          expected,
          matched,
          required,
          paid,
          now,
          created,
          prior,
          _consumed,
          row,
          _args5 = arguments,
          _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              serialized = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
              message = (outer === null || outer === void 0 || (_outer$returnMessage = outer.returnMessage) === null || _outer$returnMessage === void 0 ? void 0 : _outer$returnMessage.call(outer)) || {};
              envelope = message.data && _typeof(message.data) === 'object' ? message.data : {};
              embedded = (_envelope$transaction = envelope.transaction) !== null && _envelope$transaction !== void 0 ? _envelope$transaction : message.transaction;
              tx = outer;
              stored = serialized;
              if (!(embedded && _typeof(embedded) === 'object')) {
                _context5.n = 1;
                break;
              }
              tx = embedded;
              stored = serialized || embedded.signature || '';
              _context5.n = 2;
              break;
            case 1:
              if (!(typeof embedded === 'string' && embedded)) {
                _context5.n = 2;
                break;
              }
              stored = embedded;
              tx = this.restoreTransaction(embedded);
              if (tx) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal transaction could not be read.'
              });
            case 2:
              txmsg = ((_tx$returnMessage = (_tx = tx).returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(_tx)) || {};
              if (!(txmsg.request !== 'store-withdrawal')) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2, {
                err: 'That transaction is not a store withdrawal.'
              });
            case 3:
              sender = String(((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '').trim();
              if (!(!tx.signature || !sender)) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal transaction is not signed.'
              });
            case 4:
              if (!(typeof tx.isValid === 'function' && tx.isValid() !== true)) {
                _context5.n = 5;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal transaction signature is not valid.'
              });
            case 5:
              outerSender = String((outer === null || outer === void 0 || (_outer$from = outer.from) === null || _outer$from === void 0 || (_outer$from = _outer$from[0]) === null || _outer$from === void 0 ? void 0 : _outer$from.publicKey) || sender).trim();
              if (!(outer !== tx && outerSender !== sender)) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal transaction sender does not match the request.'
              });
            case 6:
              if (!stored && typeof tx.serialize_to_web === 'function') {
                stored = tx.serialize_to_web(this.app) || '';
              }
              _context5.n = 7;
              return this.findByTransaction(tx.signature);
            case 7:
              existing = _context5.v;
              if (!existing) {
                _context5.n = 8;
                break;
              }
              return _context5.a(2, this.finishExisting(existing, tx));
            case 8:
              data = txmsg.data;
              signature = String(txmsg.signature || '');
              if (verifyQuote(this.app, data, signature, this.mod.publicKey)) {
                _context5.n = 9;
                break;
              }
              return _context5.a(2, {
                err: 'The store withdrawal quote signature is not valid.'
              });
            case 9:
              if (!quoteIsExpired(data.timestamp)) {
                _context5.n = 10;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal quote has expired.'
              });
            case 10:
              _context5.n = 11;
              return this.findByRequest(data.timestamp);
            case 11:
              consumed = _context5.v;
              if (!(consumed && consumed.saito_tx_sig !== tx.signature)) {
                _context5.n = 12;
                break;
              }
              return _context5.a(2, {
                err: 'That withdrawal quote was already used.'
              });
            case 12:
              treasury = treasuryPublicKey(this.mod);
              if (!(data.publickey !== treasury || String(data.amount) !== String((_this$mod$fee2 = this.mod.fee) !== null && _this$mod$fee2 !== void 0 ? _this$mod$fee2 : 0) || String(data.ticker || '').toUpperCase() !== String(data.ticker || ''))) {
                _context5.n = 13;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal quote does not match the current treasury terms.'
              });
            case 13:
              ticker = String(data.ticker || '').trim().toUpperCase();
              if (!(data.ticker !== ticker)) {
                _context5.n = 14;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal quote does not match the current treasury terms.'
              });
            case 14:
              pairs = pairsFromQuote(data);
              if (pairs) {
                _context5.n = 15;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal quote identifiers are not valid.'
              });
            case 15:
              address = String(data.withdrawal_address || '').trim();
              if (address) {
                _context5.n = 16;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal address is missing from the signed quote.'
              });
            case 16:
              if (withdrawalAddressIsValid(ticker, address)) {
                _context5.n = 17;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal address is not valid for this cryptocurrency.'
              });
            case 17:
              _context5.n = 18;
              return this.eligibleSales(sender, ticker);
            case 18:
              sales = _context5.v;
              expected = this.sumSales(pairs.map(function (pair) {
                return sales.find(function (row) {
                  return row.transfer_uuid === pair.transfer && row.inbound_payment_uuid === pair.payment;
                });
              }).filter(Boolean));
              matched = pairs.every(function (pair) {
                return sales.some(function (row) {
                  return row.transfer_uuid === pair.transfer && row.inbound_payment_uuid === pair.payment;
                });
              });
              if (!(!matched || expected !== String(data.withdrawal_amount))) {
                _context5.n = 19;
                break;
              }
              return _context5.a(2, {
                err: 'The quoted proceeds are no longer eligible.'
              });
            case 19:
              required = BigInt((_this$app$wallet$conv = this.app.wallet.convertSaitoToNolan(data.amount)) !== null && _this$app$wallet$conv !== void 0 ? _this$app$wallet$conv : 0);
              paid = paidToTreasury(tx, data.publickey);
              if (!(!paid.addressed || paid.total < required)) {
                _context5.n = 20;
                break;
              }
              return _context5.a(2, {
                err: 'The transaction does not pay the treasury the required SAITO amount.'
              });
            case 20:
              now = Date.now();
              _context5.p = 21;
              _context5.n = 22;
              return this.db.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(db) {
                  var _iterator3, _step3, pair, result, _t3;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        _iterator3 = _createForOfIteratorHelper(pairs);
                        _context4.p = 1;
                        _iterator3.s();
                      case 2:
                        if ((_step3 = _iterator3.n()).done) {
                          _context4.n = 5;
                          break;
                        }
                        pair = _step3.value;
                        _context4.n = 3;
                        return db.run("UPDATE listing_sales\n             SET web3_payment_withdrawal_request = $request,\n                 web3_payment_withdrawal_publickey = $sender,\n                 web3_payment_withdrawal_address = $address,\n                 web3_payment_withdrawal_created_at = $now,\n                 updated_at = $now\n             WHERE seller = $seller\n               AND transfer_uuid = $transfer\n               AND inbound_payment_uuid = $payment\n               AND UPPER(TRIM(web3_ticker)) = $ticker\n               AND web3_payment_withdrawal_processed = 0\n               AND IFNULL(web3_payment_withdrawal_request, '') = ''\n               AND longest_chain_sold = 1", {
                          $request: data.timestamp,
                          $sender: sender,
                          $address: address,
                          $now: now,
                          $seller: sender,
                          $transfer: pair.transfer,
                          $payment: pair.payment,
                          $ticker: ticker
                        });
                      case 3:
                        result = _context4.v;
                        if (!(Number((result === null || result === void 0 ? void 0 : result.changes) || 0) !== 1)) {
                          _context4.n = 4;
                          break;
                        }
                        throw new Error('The quoted proceeds are no longer eligible.');
                      case 4:
                        _context4.n = 2;
                        break;
                      case 5:
                        _context4.n = 7;
                        break;
                      case 6:
                        _context4.p = 6;
                        _t3 = _context4.v;
                        _iterator3.e(_t3);
                      case 7:
                        _context4.p = 7;
                        _iterator3.f();
                        return _context4.f(7);
                      case 8:
                        _context4.n = 9;
                        return db.run("INSERT INTO store_withdrawals (\n             request_id, requester_publickey, treasury_publickey, ticker,\n             saito_amount, withdrawal_amount, withdrawal_address,\n             transfer_uuids, payment_uuids, quote_timestamp, quote_signature, quote_data,\n             saito_tx_sig, saito_tx, status, last_error, created_at, updated_at\n           ) VALUES (\n             $request_id, $requester, $treasury, $ticker,\n             $saito_amount, $withdrawal_amount, $withdrawal_address,\n             $transfer_uuids, $payment_uuids, $quote_timestamp, $quote_signature, $quote_data,\n             $saito_tx_sig, $saito_tx, 'accepted', '', $now, $now\n           )", {
                          $request_id: data.timestamp,
                          $requester: sender,
                          $treasury: data.publickey,
                          $ticker: ticker,
                          $saito_amount: String(data.amount),
                          $withdrawal_amount: String(data.withdrawal_amount),
                          $withdrawal_address: address,
                          $transfer_uuids: JSON.stringify(data.transfer_uuids),
                          $payment_uuids: JSON.stringify(data.payment_uuids),
                          $quote_timestamp: data.timestamp,
                          $quote_signature: signature,
                          $quote_data: canonicalJson(data),
                          $saito_tx_sig: tx.signature,
                          $saito_tx: stored || '',
                          $now: now
                        });
                      case 9:
                        return _context4.a(2, true);
                    }
                  }, _callee4, null, [[1, 6, 7, 8]]);
                }));
                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 22:
              created = _context5.v;
              _context5.n = 28;
              break;
            case 23:
              _context5.p = 23;
              _t4 = _context5.v;
              _context5.n = 24;
              return this.findByTransaction(tx.signature);
            case 24:
              prior = _context5.v;
              if (!prior) {
                _context5.n = 25;
                break;
              }
              return _context5.a(2, this.finishExisting(prior, tx));
            case 25:
              _context5.n = 26;
              return this.findByRequest(data.timestamp);
            case 26:
              _consumed = _context5.v;
              if (!_consumed) {
                _context5.n = 27;
                break;
              }
              return _context5.a(2, {
                err: 'That withdrawal quote was already used.'
              });
            case 27:
              return _context5.a(2, {
                err: (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || 'The withdrawal could not be reserved.'
              });
            case 28:
              if (created) {
                _context5.n = 29;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal could not be reserved.'
              });
            case 29:
              _context5.n = 30;
              return this.findByRequest(data.timestamp);
            case 30:
              row = _context5.v;
              if (row) {
                _context5.n = 31;
                break;
              }
              return _context5.a(2, {
                err: 'The withdrawal could not be reserved.'
              });
            case 31:
              return _context5.a(2, this.forwardWithdrawal(row.id, tx));
          }
        }, _callee5, this, [[21, 23]]);
      }));
      function acceptSubmittedTransaction(_x3) {
        return _acceptSubmittedTransaction.apply(this, arguments);
      }
      return acceptSubmittedTransaction;
    }()
  }, {
    key: "restoreTransaction",
    value: function restoreTransaction(serialized) {
      try {
        var Transaction = require('../../../lib/saito/transaction')["default"];
        var tx = new Transaction();
        tx.deserialize_from_web(this.app, serialized);
        return tx;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "findByTransaction",
    value: function () {
      var _findByTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(signature) {
        var rows;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.query("SELECT * FROM store_withdrawals WHERE saito_tx_sig = $signature LIMIT 1", {
                $signature: signature
              });
            case 1:
              rows = _context6.v;
              return _context6.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee6, this);
      }));
      function findByTransaction(_x5) {
        return _findByTransaction.apply(this, arguments);
      }
      return findByTransaction;
    }()
  }, {
    key: "findByRequest",
    value: function () {
      var _findByRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(requestId) {
        var rows;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.query("SELECT * FROM store_withdrawals WHERE request_id = $request LIMIT 1", {
                $request: requestId
              });
            case 1:
              rows = _context7.v;
              return _context7.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee7, this);
      }));
      function findByRequest(_x6) {
        return _findByRequest.apply(this, arguments);
      }
      return findByRequest;
    }()
  }, {
    key: "finishExisting",
    value: function () {
      var _finishExisting = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row, tx) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!(row.status === 'submitted')) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, {
                status: 'submitted',
                message: 'Withdrawal request submitted to the treasury. The external cryptocurrency has not been sent.',
                id: row.id
              });
            case 1:
              if (!(row.status === 'accepted' || row.status === 'forward_failed')) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, this.forwardWithdrawal(row.id, tx));
            case 2:
              return _context8.a(2, {
                status: row.status,
                message: 'Withdrawal request accepted by the Store. The external cryptocurrency has not been sent.',
                id: row.id,
                err: row.last_error || ''
              });
          }
        }, _callee8, this);
      }));
      function finishExisting(_x7, _x8) {
        return _finishExisting.apply(this, arguments);
      }
      return finishExisting;
    }()
  }, {
    key: "forwardWithdrawal",
    value: function () {
      var _forwardWithdrawal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id, tx) {
        var _this$app$network2,
          _this = this,
          _result,
          _result2;
        var rows, row, treasury, result, _this$app$modules, _this$app$modules$ret, mixin, now, _result3, error;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.query("SELECT * FROM store_withdrawals WHERE id = $id", {
                $id: id
              });
            case 1:
              rows = _context9.v;
              row = rows === null || rows === void 0 ? void 0 : rows[0];
              if (row) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, {
                err: 'The withdrawal request was not found.'
              });
            case 2:
              if (!(row.status === 'submitted')) {
                _context9.n = 3;
                break;
              }
              return _context9.a(2, {
                status: 'submitted',
                message: 'Withdrawal request submitted to the treasury. The external cryptocurrency has not been sent.',
                id: row.id
              });
            case 3:
              treasury = row.treasury_publickey;
              if (!(treasury === this.mod.publicKey)) {
                _context9.n = 7;
                break;
              }
              mixin = (_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$ret = _this$app$modules.returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'Mixin');
              if (mixin !== null && mixin !== void 0 && mixin.receiveStoreWithdrawal) {
                _context9.n = 4;
                break;
              }
              result = {
                err: 'The local Mixin module is not available.'
              };
              _context9.n = 6;
              break;
            case 4:
              _context9.n = 5;
              return mixin.receiveStoreWithdrawal(tx, {
                publicKey: this.mod.publicKey
              });
            case 5:
              result = _context9.v;
            case 6:
              _context9.n = 10;
              break;
            case 7:
              if (!(this.treasuryIsConnected(treasury) && (_this$app$network2 = this.app.network) !== null && _this$app$network2 !== void 0 && _this$app$network2.sendRequestAsTransaction)) {
                _context9.n = 9;
                break;
              }
              _context9.n = 8;
              return new Promise(function (resolve) {
                _this.app.network.sendRequestAsTransaction('store-withdrawal', {
                  module: 'Mixin',
                  transaction: row.saito_tx || ''
                }, function (response) {
                  return resolve(response || {
                    err: 'The treasury did not accept the withdrawal.'
                  });
                }, treasury);
              });
            case 8:
              result = _context9.v;
              _context9.n = 10;
              break;
            case 9:
              result = {
                err: 'The treasury is not connected.'
              };
            case 10:
              now = Date.now();
              if (!((_result = result) !== null && _result !== void 0 && _result.err || !((_result2 = result) !== null && _result2 !== void 0 && _result2.transfer_id))) {
                _context9.n = 12;
                break;
              }
              error = ((_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.err) || 'The treasury did not record the withdrawal.';
              _context9.n = 11;
              return this.run("UPDATE store_withdrawals\n         SET status = 'forward_failed', last_error = $error, updated_at = $now\n         WHERE id = $id AND status <> 'submitted'", {
                $error: error,
                $now: now,
                $id: id
              });
            case 11:
              return _context9.a(2, {
                status: 'forward_failed',
                err: error,
                message: 'The Store accepted the withdrawal, but it was not submitted to the treasury.',
                id: id
              });
            case 12:
              _context9.n = 13;
              return this.run("UPDATE store_withdrawals\n       SET status = 'submitted', last_error = '', mixin_transfer_id = $transfer, updated_at = $now\n       WHERE id = $id", {
                $transfer: result.transfer_id,
                $now: now,
                $id: id
              });
            case 13:
              return _context9.a(2, {
                status: 'submitted',
                message: 'Withdrawal request submitted to the treasury. The external cryptocurrency has not been sent.',
                id: id,
                transfer_id: result.transfer_id
              });
          }
        }, _callee9, this);
      }));
      function forwardWithdrawal(_x9, _x0) {
        return _forwardWithdrawal.apply(this, arguments);
      }
      return forwardWithdrawal;
    }()
  }]);
}();
module.exports = StoreWithdrawals;
module.exports.SUPPORT_EMAIL = SUPPORT_EMAIL;
module.exports.SUPPORT_URL = SUPPORT_URL;
module.exports.treasuryPublicKey = treasuryPublicKey;
module.exports.canonicalJson = canonicalJson;